import type { GroupListQuery, GroupMeetingQuery } from '@/api/groups-api'

/**
 * Query keys for the group module.
 *
 * Health has a key of its own even though `GroupDetail` already carries a snapshot of it. The two
 * are not the same fact: the detail carries the snapshot that was stored when the group was last
 * read, and `/groups/{id}/health` is what a recompute writes to. Keeping them apart means asking
 * for a fresh score updates the panel that shows it without re-reading the whole group, and
 * invalidating the group after a membership change does not silently discard a score somebody is
 * mid-way through reading.
 */
export const groupKeys = {
  all: ['groups'] as const,
  lists: () => [...groupKeys.all, 'list'] as const,
  list: (query: GroupListQuery) => [...groupKeys.lists(), query] as const,
  details: () => [...groupKeys.all, 'detail'] as const,
  detail: (groupId: string) => [...groupKeys.details(), groupId] as const,
  health: (groupId: string) => [...groupKeys.all, 'health', groupId] as const,
  meetingLists: (groupId: string) => [...groupKeys.all, 'meetings', groupId] as const,
  meetings: (groupId: string, query: GroupMeetingQuery) =>
    [...groupKeys.meetingLists(groupId), query] as const,
}
